var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43909 25.8461L3.41242 25.8727C3.05242 25.0861 2.82576 24.1927 2.73242 23.2061C2.82576 24.1794 3.07909 25.0594 3.43909 25.8461Z",
    fill: "#A4A1B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 14.3398C13.7521 14.3398 15.1728 12.9191 15.1728 11.1665C15.1728 9.41391 13.7521 7.99316 11.9995 7.99316C10.2469 7.99316 8.82617 9.41391 8.82617 11.1665C8.82617 12.9191 10.2469 14.3398 11.9995 14.3398Z",
    fill: "#A4A1B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 3.16699H10.4127C5.55935 3.16699 2.66602 6.06033 2.66602 10.9137V22.087C2.66602 23.5403 2.91935 24.807 3.41268 25.8737C4.55935 28.407 7.01268 29.8337 10.4127 29.8337H21.586C26.4394 29.8337 29.3327 26.9403 29.3327 22.087V19.0337V10.9137C29.3327 6.06033 26.4394 3.16699 21.586 3.16699ZM27.1594 17.167C26.1194 16.2737 24.4394 16.2737 23.3993 17.167L17.8527 21.927C16.8127 22.8203 15.1327 22.8203 14.0927 21.927L13.6393 21.5537C12.6927 20.727 11.186 20.647 10.1193 21.367L5.13268 24.7137C4.83935 23.967 4.66602 23.1003 4.66602 22.087V10.9137C4.66602 7.15366 6.65268 5.16699 10.4127 5.16699H21.586C25.346 5.16699 27.3327 7.15366 27.3327 10.9137V17.3137L27.1594 17.167Z",
    fill: "#A4A1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLoading);
export default __webpack_public_path__ + "static/media/image-loading.ab0dcab8d68fd151a149bfa4feb49976.svg";
export { ForwardRef as ReactComponent };